import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discount-group-person',
  templateUrl: './discount-group-person.component.html',
  styleUrls: ['./discount-group-person.component.css']
})
export class DiscountGroupPersonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
